import { render, staticRenderFns } from "./TableGroupsComponent.vue?vue&type=template&id=6613ea64&"
import script from "./TableGroupsComponent.vue?vue&type=script&lang=js&"
export * from "./TableGroupsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableGroupsComponent.vue?vue&type=style&index=0&id=6613ea64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports